<template>
  <div>
    <template v-if="currentImage">
      <div
        class="text-xs-center"
        style="position:relative;overflow:hidden;background: #eee;border-radius: 5px;"
      >
        <img
          :src="currentImage"
          alt="Upload Product Image"
          style="height: 250px;margin-bottom: -10px"
        />
        <div
          style="background: #00000036; width: 100%; height: 100%;position:absolute; left: 0; right: 0;bottom: 0; top: 0"
          :style="{ opacity: showUpload ? 1 : 0 }"
          @mouseover="showUpload = true"
          @mouseleave="showUpload = false"
        >
          <p
            class="text-xs-center"
            style="position:absolute;top: 50%;left:0;right: 0;margin-top:-26px;"
          >
            <v-btn dark :color="theme.color" @click="onClickUploadFile()" :loading="loading">
              <v-icon class="mr-2">mdi-camera</v-icon>
              {{ $t("Select file to upload2") }}
            </v-btn>
            <br />
            <span class="caption white--text">
              {{ $t("Upload file size: {size}MB", { size: 20 }) }}
            </span>
          </p>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        style="height:250px;background:#eee;overflow:hidden;position:relative"
        :style="{ height: height + 'px' }"
      >
        <template v-if="loading">
          <div style="position:absolute;top: 50%;left:50%;margin-top:-10px;margin-left:-21px">
            <sync-loader :key="theme.color" :color="theme.color" :size="'10px'"></sync-loader>
          </div>
        </template>
        <template v-else>
          <p
            class="text-xs-center"
            style="position:absolute;top: 50%;left:0;right: 0;margin-top:-26px;"
          >
            <v-btn dark :color="theme.color" @click="onClickUploadFile()" :loading="loading">
              <v-icon class="mr-2">mdi-camera</v-icon>
              {{ $t("Select file to upload2") }}
            </v-btn>
            <br />
            <span class="caption">
              {{ $t("Upload file size: {size}MB", { size: 20 }) }}
            </span>
          </p>
        </template>
      </div>
    </template>

    <input
      type="file"
      v-show="false"
      ref="inputUpload"
      class="form-control-file pt-2"
      name="photoUpload"
      id="photoUploadInput"
      data-vv-as="File"
      v-validate="'image|size:20480'"
      :key="`upload_${uploadtimestamp}`"
      @change="onFileChange($event)"
      style="overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;"
    />

    <div class="has-error" v-if="isAlert">
      <p class="text-error">{{ $t("Something went wrong. Please try it again.") }}</p>
    </div>
    <div class="has-error">
      <p class="text-error" v-show="errors.has('photoUpload')">{{ errors.first("photoUpload") }}</p>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import axios from "axios";
import moment from "moment";
import SyncLoader from "vue-spinner/src/SyncLoader.vue";
import { mapGetters } from "vuex";

export default {
  props: {
    value: null,
    height: {
      default: 100,
      type: Number,
    },
    outputtype: {
      default: "url",
      type: String,
    },
  },
  data: function() {
    return {
      base64img: "",
      showUpload: false,
      currentImage: this.value,
      isAlert: false,
      config: {
        color: config.color,
      },
      loading: false,
      uploadtimestamp: moment().format("x"),
    };
  },
  components: {
    SyncLoader,
  },
  computed: {
    isCDS() {
      return this.pageProfile && this.$store.state.cds.includes(this.pageProfile.pageid);
    },
    ...mapGetters({
      theme: "getTheme",
      pageProfile: "getPageProfile",
    }),
  },
  async mounted() {},
  methods: {
    async onClickUploadFile() {
      this.uploadtimestamp = moment().format("x");
      if (navigator.userAgent.match(/FB/)) {
        //
      }
      await this.$nextTick();
      this.$refs.inputUpload.multiple = true;
      await this.$nextTick();
      this.$refs.inputUpload.click();
    },
    onClickUploadBtn() {
      document.getElementById("photoUploadInput").click();
    },
    fileResize: function(file) {
      let vm = this;
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onloadend = function() {
          var tempImg = new Image();
          tempImg.src = reader.result;
          tempImg.onload = function() {
            var MAX_WIDTH = 1000;
            var MAX_HEIGHT = 1000;
            if (vm.pageProfile.type == "monobo") {
              MAX_WIDTH = 500;
              MAX_HEIGHT = 500;
            }
            var tempW = tempImg.width;
            var tempH = tempImg.height;
            if (tempW > tempH) {
              if (tempW > MAX_WIDTH) {
                tempH *= MAX_WIDTH / tempW;
                tempW = MAX_WIDTH;
              }
            } else {
              if (tempH > MAX_HEIGHT) {
                tempW *= MAX_HEIGHT / tempH;
                tempH = MAX_HEIGHT;
              }
            }
            var canvas = document.createElement("canvas");
            canvas.width = tempW;
            canvas.height = tempH;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(this, 0, 0, tempW, tempH);
            var dataURL = canvas.toDataURL("image/jpeg");
            var data = "image=" + dataURL;
            try {
              if (vm.outputtype == "base64") {
                vm.$emit("input", dataURL);
                vm.currentImage = dataURL;
              }
              var obj = vm.dataURItoBlob(data);
              obj.name = file.name;
              resolve(obj);
            } catch (error) {
              vm.$swal({
                title: "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง",
                type: "error",
                text: `dataURItoBlob: ${error}`,
                confirmButtonText: vm.$t("Confirm"),
              });
              reject();
            }
          };
        };
        reader.readAsDataURL(file);
      });
    },
    dataURItoBlob: function(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0) byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);

      // separate out the mime component
      var mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], { type: mimeString });
    },
    onFileChange: async function(event) {
      var vm = this;
      this.isAlert = false;

      var result = await this.$validator.validate();
      if (!result) {
        // do stuff if not valid.
        this.uploadtimestamp = moment().format("x");
        return;
      } else {
        let files = event.target.files || event.dataTransfer.files;
        if (!files.length) {
          this.uploadtimestamp = moment().format("x");
          return;
        }
        try {
          var obj = await vm.fileResize(files[0]);
          if (this.outputtype != "base64") {
            this.createImage(obj);
          }
          event.target.value = "";
        } catch (error) {
          this.$swal({
            title: "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง",
            type: "error",
            text: `fileResize: ${error}`,
            confirmButtonText: this.$t("Confirm"),
          });
        }
      }
    },
    createImage(file) {
      // let reader = new FileReader();

      try {
        this.upload(file);
      } catch (error) {
        this.$swal({
          title: "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง",
          type: "error",
          text: `upload: ${error}`,
          confirmButtonText: this.$t("Confirm"),
        });
      }
    },
    async upload(file) {
      let data = {
        name: file.name,
        type: file.type,
        file: file,
      };
      let vm = this;
      vm.loading = true;

      let url =
        config.getConfig("serverUrl") +
        "sign-s3?file-name=" +
        data.name +
        "&file-type=" +
        data.type;

      try {
        var response = await axios.get(url);
        response = response.data;
        response.file = data.file;
        await this.uploadfile(response);
        vm.currentImage = response.url;
        vm.loading = false;
        vm.uploadtimestamp = moment().format("x");
        vm.$emit("input", vm.currentImage);
      } catch (error) {
        this.$swal({
          title: "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง",
          type: "error",
          text: `uploadfile: ${error}`,
          confirmButtonText: this.$t("Confirm"),
        });
        vm.loading = false;
        vm.isAlert = true;
      }
    },
    uploadfile: function(data) {
      return new Promise((resolve, reject) => {
        let signedRequest = data.signedRequest;
        let request = data.file;
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", signedRequest);
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              resolve();
            } else {
              reject("Could not upload file.");
            }
          }
        };
        xhr.send(request);
      });
    },
  },
  watch: {
    value: function(newVal) {
      this.currentImage = newVal;
    },
  },
};
</script>
